module.exports = __webpack_public_path__ + "img/hissy.8da527b6.png";